import { setLocation } from 'js/lib/coursera.redirect';

import localStorageEx from 'bundles/common/utils/localStorageEx';
import { LOCAL_STORAGE_KEY_POSTPONED_ONBOARDING } from 'bundles/onboarding-2018/constants';

// For use outside of components. Components should use the hook api below
export const registerPostponedOnboarding = () => {
  localStorageEx.setItem(LOCAL_STORAGE_KEY_POSTPONED_ONBOARDING, true, JSON.stringify);
};

export const useDeferredOnboarding = () => {
  return {
    registerPostponedOnboarding,
    showOnboardingIfPostponed: () => {
      const shouldViewOnboarding = localStorageEx.getItem(
        LOCAL_STORAGE_KEY_POSTPONED_ONBOARDING,
        JSON.parse,
        false,
        false,
        false
      );

      localStorageEx.removeItem(LOCAL_STORAGE_KEY_POSTPONED_ONBOARDING);
      if (shouldViewOnboarding) {
        setLocation('/onboarding-2022');
      }
    },
  };
};
